import { useMemo } from "react";
import { useAccounts } from ".";

export const useAccountFromExchangeId = (exchangeId: string | null) => {
  const { accounts } = useAccounts();
  const account = useMemo(() => {
    return accounts.find((account) => account.exchangeId === exchangeId);
  }, [accounts, exchangeId]);
  return account;
};
